import { useContext } from 'react'

import { AuthConfigContext } from '../providers/AuthenticationProvider'

export const useAuthentication = () => {
  return useContext(AuthConfigContext)
}
